<template>
  <div class="page-congress" @click="toLink">
    <img src="https://qiniu.laway.cn/yn/2023/04/28/a1905800e5aa11ed9d4db4055d0b07be.png" width="350" alt="">
    <h2>云南省人大常委会基层立法联系点</h2>
    <h2>昆明市人大常委会基层立法联系点</h2>
    <p> 立法建议网上征集平台（请点击屏幕进入） </p>

  </div>
</template>
<script>
export default {
  methods: {
    toLink () {
      this.$router.push(`/iframes?urls=${encodeURIComponent('http://whlf.kmrd.cn:8081/whpf/whpfHome')}&showHead=1`)
    }
  }
}
</script>
<style lang="stylus" >
.page-congress
  width 100%
  height 100vh
  background-image url('https://qiniu.laway.cn/yn/2023/04/28/061ee388e5a911ed9d4db4055d0b07be.jpg')
  background-repeat no-repeat
  background-size 100% 100%
  display flex
  font-size 80px
  flex-direction column
  padding-top 160px
  color #fff
  align-items center
  letter-spacing 2px
  img
    margin-bottom 30px
  h2
    margin 15px 0
  p
    margin-top 140px
    font-size 26px
    color #ed2a24
.page-congress+ .control
  display none
</style>